import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../../pagination.js';
import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

import { ProductResponseSchema } from './product.schemas.js';

export const ProductListSortFieldSchema = z.enum(['name', 'sku', 'brand', 'status']);
export type ProductListSortField = z.infer<typeof ProductListSortFieldSchema>;

export const ListProductsQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(2).max(100).optional(),
  ),
  status: CatalogItemStatusSchema.optional(),
  categoryId: z.uuid().optional(),
  subcategoryId: z.uuid().optional(),
  brandId: z.uuid().optional(),
  sort: ProductListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export const ListProductsResponseSchema = z.object({
  items: z.array(ProductResponseSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListProductsQuery = z.infer<typeof ListProductsQuerySchema>;
export type ListProductsResponse = z.infer<typeof ListProductsResponseSchema>;
